import * as React from "react";
import ChevronLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import ChevronRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MuiCircularProgress from "@mui/material/CircularProgress";

import { lang } from "../../lang";
import { FlexHorizontal, FlexSpacer } from "../../components/atoms/Flex";
import { TableColumnProps, TableProps, TablePropsData } from "../../interface";

class Table extends React.Component<React.HTMLAttributes<HTMLTableElement> & TableProps> {
    public state = {
        currentPage: 1
    };
    public render(): React.ReactElement {
        const { data, id, columnNames, onClickRow, pageSize, onPageChange, loading } = this.props;
        let { totalItems } = this.props;
        const { currentPage } = this.state;
        const clickable = onClickRow ? true : false;
        let pageCount = 0;
        let pageData = data;
        if (pageSize) {
            totalItems = totalItems || data.length;
            pageCount = Math.ceil(totalItems / pageSize);
            const pageStart = (currentPage - 1) * pageSize;
            pageData = data.slice(pageStart, pageStart + pageSize);
        }
        return (
            <table>
                <thead className="filter">
                    <tr className="row not_hover">
                        {columnNames.map((column, nameNum) => (
                            <th
                                className="cell"
                                key={nameNum}
                                style={{
                                    minWidth: column.width ? undefined : "100px",
                                    whiteSpace: column.nowrap ? "nowrap" : undefined,
                                    width: column.width ? column.width : undefined
                                }}
                            >
                                {column.name}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody data-at_id={this.props["data-at_id"] || "table"}>
                    {loading ? (
                        <tr className="row">
                            <td colSpan={columnNames.length}>
                                <MuiCircularProgress
                                    data-at_id="icon_progress"
                                    style={{
                                        margin: "8px"
                                    }}
                                    size={18}
                                />
                            </td>
                        </tr>
                    ) : (
                        pageData.map((row: TablePropsData, rowNum) => (
                            <tr
                                className={`row ${clickable ? "clickable" : ""}`}
                                key={rowNum}
                                id={id ? `${id}-${rowNum}` : undefined}
                                style={{
                                    background: row._error ? "rgb(255,224,224)" : "",
                                    borderBottom: rowNum !== pageData.length - 1 ? "1px solid rgb(204,204,204)" : "0px"
                                }}
                                data-at_id="table_tr"
                            >
                                {columnNames.map((column: TableColumnProps, colNum) => {
                                    return (
                                        <td
                                            className={`${column.dataAtId ? column.dataAtId + " " : ""}cell`}
                                            style={{
                                                cursor: onClickRow ? "pointer" : undefined,
                                                whiteSpace: column.nowrap ? "nowrap" : undefined
                                            }}
                                            key={colNum}
                                            onClick={() => {
                                                if (onClickRow) {
                                                    onClickRow(row, column.id);
                                                }
                                            }}
                                            data-at_id={column.dataAtId}
                                        >
                                            {(() => {
                                                if (column.icon) {
                                                    return row[column.id] ? <column.icon /> : !!row[column.id];
                                                } else if (column.transform) {
                                                    return column.transform(row[column.id] as string);
                                                } else {
                                                    return String(row[column.id]);
                                                }
                                            })()}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))
                    )}
                    {pageSize && (
                        <tr className="row not_hover">
                            <td data-at_id={pageCount > 0 ? "" : "nothing_add"} className="cell" colSpan={columnNames.length}>
                                <FlexHorizontal>
                                    <FlexSpacer>
                                        {pageCount > 0 ? `${lang.page} ${currentPage} ${lang.of} ${pageCount}` : lang.nothingAddedYet}
                                    </FlexSpacer>
                                    {pageCount > 1 && (
                                        <>
                                            <ChevronLeftIcon
                                                data-at_id="pagination_left"
                                                className="chevron_icon"
                                                style={{
                                                    pointerEvents: currentPage === 1 ? "none" : undefined
                                                }}
                                                onClick={() => {
                                                    if (currentPage === 1) {
                                                        return;
                                                    }
                                                    if (onPageChange) {
                                                        onPageChange(this.state.currentPage - 1);
                                                    }
                                                    this.setState({
                                                        currentPage: this.state.currentPage - 1
                                                    });
                                                }}
                                            />
                                            <ChevronRightIcon
                                                data-at_id="pagination_right"
                                                className="chevron_icon"
                                                style={{
                                                    pointerEvents: currentPage === pageCount ? "none" : undefined
                                                }}
                                                onClick={() => {
                                                    if (currentPage === pageCount) {
                                                        return;
                                                    }
                                                    if (onPageChange) {
                                                        onPageChange(this.state.currentPage + 1);
                                                    }
                                                    this.setState({
                                                        currentPage: this.state.currentPage + 1
                                                    });
                                                }}
                                            />
                                        </>
                                    )}
                                </FlexHorizontal>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
}

export { Table };
